import { useMemo } from 'react';

interface MediaUrls {
  audioMessages: string[];
  imageMessages: string[];
}

export function useMediaUrls(mediaUrls?: string[]): MediaUrls {
  return useMemo(() => {
    const audioMessages: string[] = [];
    const imageMessages: string[] = [];

    if (!mediaUrls) {
      return { audioMessages, imageMessages };
    }

    const processedUrls = new Set<string>();

    mediaUrls.forEach((url) => {
      if (processedUrls.has(url)) {
        return;
      }

      processedUrls.add(url);

      if (url.includes('.wav')) {
        audioMessages.push(url);
      } else if (
        url.includes('.jpg') ||
        url.includes('.png') ||
        url.includes('.webp') ||
        url.includes('.mp4') ||
        url.includes('.webm') ||
        url.includes('.ogg') ||
        url.includes('.pdf')
      ) {
        imageMessages.push(`${process.env.NEXT_PUBLIC_CDN}/${url}`);
      }
    });

    return { audioMessages, imageMessages };
  }, [mediaUrls]);
}
